import Mqtt from  'mqtt';

let client = null;

export const connect = (url, messageCb, closeCb)  => {
    return new Promise((resolve, reject) => {

        client = Mqtt.connect(url, {reconnectPeriod: 0});

        client.on('connect', () => {
            resolve('success');
        });

        client.on('error', err => {
            reject(err);
        });     

        client.on('close', closeCb);

        client.on('message', messageCb)
    });
}

export const closeClient = () => {
    if (!client) {
        return Promise.resolve('success');
    }
    return new Promise(resolve => {
        client.end(false, () => {
            return resolve('success');
        })
    });
}

export const reConnect = () => {
    if (!client) {
        throw new Error('client does not exist');
    }
    if (client.isConnected) {
        return true;
    }

    client.reConnect();
    return true;
}

export const isConnected = () => {
    if (!client) {
        return false;
    }

    return client.connected;
}

export const subscribe = (topics, qos = 1) => {
    return new Promise((resolve, reject) => {
        if (!client) {
            return reject('no client defined, try connect() before subscribing')
        }

        if (!topics || topics.length === 0) {
            return reject('topic required');
        }

        client.subscribe(topics, {qos},(err, granted) => {
            if(err) {
                return reject(err);
            }
            return resolve(granted);
        });
    });
}

export const unsubscribe = topic => {
    return new Promise((resolve, reject) => {
        if (!client) {
            return reject('client does not exist');
        }
        if (!topic) {
            return reject('topic required');
        }

        client.unsubscribe(topic, err => {
            if (err) {
                return reject(err);
            }

            return resolve(`successfully unsubscribed from topic: ${topic}`);
        });
    });
}

export default function() { return { connect, closeClient, reConnect, isConnected, subscribe, unsubscribe }}


// WEBPACK FOOTER //
// ./notification/Client/MqttClient.js